import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { AuthService, User } from '@auth0/auth0-angular';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { LogoutModalComponent } from './logout-modal/logout-modal.component';
import { LayoutService } from '../../layout.service';
import { InvitationsComponent } from '../../invitations/invitations.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { DropdownComponent } from '../../../shared/components/dropdown/dropdown.component';
import { OrganizationSelectComponent } from './organization-select/organization-select.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { UserGuideButtonComponent } from '../user-guide-button/user-guide-button.component';
import { LanguageButtonComponent } from '../../../shared/components/language-button/language-button.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    OrganizationSelectComponent,
    DropdownComponent,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    AsyncPipe,
    TranslateModule,
    UserGuideButtonComponent,
    LanguageButtonComponent,
  ],
})
export class HeaderComponent implements OnInit {
  auth = inject(AuthService);
  private dialog = inject(MatDialog);
  layoutService = inject(LayoutService);

  @Output() protected toggleSidenav: EventEmitter<void> = new EventEmitter<void>();

  @Input() showToggleSidenav: boolean;

  user: User;

  ngOnInit(): void {
    this.auth.user$.subscribe((user) => {
      this.user = user;
    });
  }

  changePassword() {
    this.dialog.open(ChangePasswordModalComponent, {
      data: { email: this.user.email },
    });
  }

  insertInvitationCode() {
    this.dialog.open(InvitationsComponent, { disableClose: true, data: {} });
  }

  onTransitionEnd() {
    dispatchEvent(new Event('resize'));
  }

  logout() {
    this.dialog.open(LogoutModalComponent);
  }

  emitToggleSidenav() {
    this.toggleSidenav.emit();
  }
}
